import { EstadoAssociacaoItemNFeEntradaEnum } from '@shared/enums/suprimentos/estado-associacao-item-nfe-entrada.enum';
import { VinculoPedidoNotaItemStruct } from '@shared/services/structs/orquestrador-compras/vinculo-pedido-nota-item.struct';

/**
 * Cópia local, para o Kanban (card, gaveta e fluxo do vínculo), da regra de "item ainda em associação" da
 * NF-e de entrada (`nota-fiscal-entrada-documento/components/nfe-entrada-itens/nfe-entrada-itens.associacao.ts`,
 * mesma regra do `AssociacaoNFeEntradaHelper.Validar` do OrquestradorCompras): item sem produto ou não
 * confirmado, ou item associado cuja unidade da nota difere da unidade do produto sem fator de conversão
 * confirmado e maior que zero.
 *
 * Aqui a unidade do produto vem no próprio item do contexto do vínculo (`unidadeEstoque`); sem ela (falha
 * no cadastro do produto) o item fica pendente, como na tela da nota.
 */
export function isItemAssociacaoPendente(item: VinculoPedidoNotaItemStruct): boolean {
  if (item.idEstadoAssociacaoItemNFeEntrada !== EstadoAssociacaoItemNFeEntradaEnum.Associado || !item.idProduto) return true;
  if (item.isFatorConversaoConfirmado && !!item.fatorConversao && item.fatorConversao > 0) return false;
  if (item.unidadeEstoque === null || item.unidadeEstoque === undefined) return true;
  return normalizarUnidade(item.unidadeComercial) !== normalizarUnidade(item.unidadeEstoque);
}

/** Mesma normalização do modal de associação (sem caixa, acentos e espaços nas pontas). */
function normalizarUnidade(texto: string | null | undefined): string {
  return (texto ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
}
